/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PriceKind } from './priceKind';
import { PaymentFrequency } from './paymentFrequency';

/**
 * Calculated price.   Currency is always euro and cent.   (german: Beitrag) (bipro-produktmodell::Beitrag)
 */
export interface Price {
  kind?: PriceKind;
  paymentFrequency?: PaymentFrequency;
  /**
   * The monetary amount according to the given payment frequency.   Format is *eee.cc* , separated by dot.   Default currency is Euro and Cent.   (german: Geldbetrag)   (bipro-datentypen::Betrag)
   */
  amount?: string;
  /**
   * The monetary amount accumulated for one year.   In case of yearly payment frequency the *amount* and *annualAmount* are identical.   Format is *eee.cc* , separated by dot.   Default currency is Euro and Cent.   (german: Geldbetrag)   (bipro-datentypen::Betrag)
   */
  annualAmount?: string;
}
export namespace Price {}
